import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {CounselingService} from "../../counseling.service";
import {DatePipe} from "@angular/common";
import Timestamp = firebase.firestore.Timestamp;
import {AddIndividualSessionComponent} from "../add-individual-session/add-individual-session.component";

import {ViewIndividualAssessmentComponent} from "../view-individual-assessment/view-individual-assessment.component";
import {EditIndividualCounselingComponent} from "../edit-individual-counseling/edit-individual-counseling.component";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {FormControl} from "@angular/forms";
import {CentreService} from "../../../../services/centre.service";
import {Centre} from "../../../../interfaces/Centres";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import {MatSort} from "@angular/material/sort";
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {LogService} from "../../../../services/log.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import {EmployeeService} from "../../../../services/employee.service";
import {environment} from "../../../../../environments/environment";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {PermissionService} from "../../../../components/employee/permission-service.service";
import {elements} from "chart.js";

@Component({
    selector: 'app-individual-assessment-table',
    templateUrl: './individual-session-table.component.html',
    styleUrls: ['./individual-session-table.component.scss']
})
export class IndividualSessionTableComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    displayedColumns: string[] = ['sr.no','date', 'childName', 'centreName', 'challengesFaced', 'type', 'submittedBy', 'createdAt', 'Action'];
    dataSource!: MatTableDataSource<any>;
    centreControl = new FormControl('');
    protected readonly PermissionType = PermissionType;

    selectedCentre = 'All';
  // Multi-centre selection (Select All support). Empty array => no centre filter (all centres).
  selectedCentreCodes: string[] = [];

  selectedCentreObj: any = null;
  submittedByObj: any = null;


  displayType = (o: any) => o?.centreName;

  displaysubmittedBy = (o: any) => o?.userName;


  data: any;
    start?: Date;
    end?: Date;
    currentDate = new Date().getTime();
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    _centres$: Observable<Centre[]>;
    @ViewChild(MatSort) sort!: MatSort;
    env = isDevMode() ? environment.testMode : environment.productionMode;
    permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[];
    // counselling = this.permissions.filter((x) => x.functionName == 'Counselling');
    submittedBy: string | undefined | null = 'All';
    sessionType: string | undefined | null = "All";
    counsellors$: Observable<any[]>;
    mAllData: any[] = [];
    sessionTypes = ["Admission Rapport building counselling", "Discharge Counselling", "Follow-up Counselling", "Regular Counselling"];
    isLoading: boolean = false;  // New loading flag

    constructor(
        private readonly matDialog: MatDialog,
        private readonly counselingService: CounselingService,
        private readonly datePipe: DatePipe,
        private readonly mFirestore: AngularFirestore,
        private readonly centreService: CentreService,
        private readonly mLogService: LogService,
        private readonly mEmployeeService: EmployeeService,
        private permissionService: PermissionService
    ) {
        this._centres$ = this.centreService.getAllCentres().pipe(
            map(centres => {
                const sorted = [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim()));
                // Prepend an "All Centres" option so the user can clear the centre filter from the dropdown itself
                return [{centreCode: 'All', centreName: 'All Centres'} as Centre, ...sorted];
            })
        );
        this.counsellors$ = this.mEmployeeService.getCounsellers();
        // Dump all permissions for debugging
        this.permissionService.debugDumpPermissions();

        // Check specific permission
        this.permissionService.hasPermission('Prescreening List', PermissionType.EDIT)
            .pipe(takeUntil(this._destroyed$))
            .subscribe(result => {
                console.debug('Permission check result:', result);
            });

    }

    ngOnInit()
        :
        void {
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    clearAll() {
        // Clear input fields
        this.start = undefined;
        this.end = undefined;
        this.selectedCentre = 'All';
        this.selectedCentreCodes = [];
        this.selectedCentreObj = [];
        this.centreControl.reset();
        this.centreControl.setValue('All');
        this.submittedBy = 'All';
        this.sessionType = 'All';
        // Clear loaded data
        this.dataSource.data = [];
    }


  onCentreChange(selected: any) {
    this.selectedCentreObj = selected;              // UI binding (array in multiple mode)
    const list = Array.isArray(selected) ? selected : (selected ? [selected] : []);
    // Ignore the "All Centres" sentinel option — an empty list already means "all centres"
    this.selectedCentreCodes = list
      .map(c => c?.centreCode)
      .filter((code: string) => code && code !== 'All');
    // Keep the legacy single-value field roughly in sync for any code paths that still read it
    this.selectedCentre = this.selectedCentreCodes.length === 1 ? this.selectedCentreCodes[0] : 'All';
  }


  onSubmittedByChange(selected: any) {
    this.submittedByObj = selected;                  // UI binding
    this.submittedBy = selected?.userName ?? 'All';  // filtering (existing logic)
  }


  onCentreSelect($event
                   :
                   MatSelectChange
    ) {
        this.selectedCentre = $event.value;
    }

    openIndividualSessionDialog() {
        this.matDialog.open(AddIndividualSessionComponent, {
            height: '90%',
            disableClose: true,
        });
    }

    getDate(date
            :
            Date
    ):
        any {
        let d = (date as unknown as Timestamp).toDate();
        let datePipeString = this.datePipe.transform(d, 'dd/MM/yyyy');
        return datePipeString;
    }

    viewDialog(element
               :
               any
    ) {
        this.matDialog.open(ViewIndividualAssessmentComponent, {
            data: element,
            width: '800%',
            height: '90%'
        });
        let activity = {
            date: new Date().getTime(),
            section: 'Individual Counseling',
            action: 'View',
            description: `Session for ${element.childCode} Viewed in Counseling by user`,
            currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
    }

    viewEdit(element: any) {
        this.matDialog.open(EditIndividualCounselingComponent, {
            data: element,
            width: '800%',
            disableClose: true,
            height: '90%'
        });
    }

  onTypeSelect(selected: any) {
    this.selectedCentre = selected?.centreCode ?? 'All';
    this.submittedBy=selected?.userName?? 'All';
  }


  @needConfirmation()
    delete(element
           :
           any
    ) {
        this.counselingService.deleteIndividualSession(element);
        let activity = {
            date: new Date().getTime(),
            section: 'Individual Counseling',
            action: 'Delete',
            description: `Session for ${element.childCode} Deleted in Counseling by`,
            currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
    }

    applyFilter(event
                :
                Event
    ) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    search() {
        this.isLoading = true;  // Start loading
        // Fetch a single centre server-side when exactly one is selected; otherwise fetch all
        // and narrow by the selected centres client-side (handles the Select All case).
        const serverCentre = this.selectedCentreCodes.length === 1 ? this.selectedCentreCodes[0] : 'All';
        const narrowByCentre = (rows: any[]) => {
            if (this.selectedCentreCodes.length <= 1) return rows;
            const centreSet = new Set(this.selectedCentreCodes);
            return rows.filter((r: any) => centreSet.has(r.centreCode));
        };
        if (this.start !== null && this.end != null) {
            this.counselingService.fetchIndividualSessionsWithSortingByDate(serverCentre, this.start, this.end).pipe(takeUntil(this._destroyed$)).subscribe(tables => {
                // @ts-ignore
                this.data = narrowByCentre(tables.sort((a, b) => b.date - a.date)); // Sort by date
                this.dataSource = new MatTableDataSource(this.data);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.applyfilters();
                this.isLoading = false;  // Stop loading
            });
        } else {
            this.counselingService.fetchIndividualSessionsWithSorting(serverCentre).pipe(takeUntil(this._destroyed$)).subscribe(tables => {
                // @ts-ignore
                this.data = narrowByCentre(tables.sort((a, b) => b.date - a.date)); // Sort by date
                this.applyfilters();
                this.dataSource = new MatTableDataSource(this.data);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.isLoading = false;  // Stop loading
            });
        }
    }

    dynamicSearch() {
        this.isLoading = true;  //
        let activity = {
            date: new Date().getTime(),
            section: 'Group Education',
            action: 'Filter',
            description: `Education Filter Session count by user`,
            currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
        let myQuery: firebase.firestore.Query<any> = this.mFirestore.collection(this.env.counseling + '/allSessions/sessions', ref => ref.orderBy('date', 'desc')).ref;

        const centreCodes = this.selectedCentreCodes;
        // Firestore "in" supports up to 10 values; for larger selections we filter client-side below
        if (centreCodes.length > 0 && centreCodes.length <= 10) {
            myQuery = myQuery.where('centreCode', 'in', centreCodes);
        }
        if (this.start != null && this.end != null) {
            myQuery = myQuery.where('date', '>=', this.start)
                .where('date', '<=', this.end);
        }
        if (this.submittedBy != 'All') {
            myQuery = myQuery.where('submittedBy', '==', this.submittedBy);
        }
        if (this.sessionType != 'All') {
            myQuery = myQuery.where('type', '==', this.sessionType);
        }

        myQuery.get().then(res => {
            let sessions = res.docs.map(x => ({id: x.id, ...x.data()})).sort((a, b) => b.date - a.date); // Sort by date
            if (centreCodes.length > 10) {
                const centreSet = new Set(centreCodes);
                sessions = sessions.filter((s: any) => centreSet.has(s.centreCode));
            }
            sessions.forEach(it => {
                // it.isEditable ==
                console.log(this.editAccess(it))
            })
            this.isLoading = false;  // Stop loading
            this.dataSource = new MatTableDataSource<any>(sessions);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

// editAccess(element: any): boolean {
//   const userData = JSON.parse(localStorage.getItem('userData')!);
//   const username = userData?.userName;
//   // const username =/ userData?.userName;
//   return ( element.submittedBy==username && ((this.currentDate - element.createdAt) <= 86400000*2));
//
// }
    editAccess(element
               :
               any
    ):
        boolean {
        const ONE_DAY_IN_MILLISECONDS = 86400000;
        const TWO_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 2;
        const THREE_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 3;
        const FOUR_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 4;
        // console.log('into editAccess')
        // const currentTimestamp = firebase.firestore.Timestamp.fromDate(this.currentDate);
        const userData = JSON.parse(localStorage.getItem('userData')!)
        const username = userData?.userName
        // alert(currentDate.getTime() - element.createdAt)
        const currentTimestamp = Timestamp.now();
        const sessionTimestamp = element.createdAt
        // console.log('element.createdAt',element.createdAt)
        // const sessionTimestamp = firebase.firestore.Timestamp.fromDate((element.createdAt  as Timestamp).toDate()).toMillis()
        const timeDifference = currentTimestamp.toMillis() - sessionTimestamp;

        return (username === element.submittedBy && timeDifference <= THREE_DAYS_IN_MILLISECONDS) || username=='Krisha Shah'

      // return username == 'Krisha Shah'
        // console.log(element.createdAt,this.currentDate )
        // console.log(this.currentDate - element.createdAt ,this.currentDate - element.createdAt <= 86400000)
        // console.log('CreatedAt',)
        // return (username == element.personConductingTest && ((this.currentDate - element.createdAt) <= TWO_DAYS_IN_MILLISECONDS))
    }

    applyfilters() {
        this.dataSource.data = this.data;
        if (this.dataSource.data.length >= 1) {
            if (this.submittedBy != null) {
                this.dataSource.data = this.data.filter((x: any) => x.submittedBy == this.submittedBy);
            }
            if (this.sessionType != null) {
                this.dataSource.data = this.data.filter((x: any) => x.type == this.sessionType);
            }
        }
    }

    protected readonly elements = elements;

  /**
   * Toggle the highlight status of a counseling session.
   * Updates the highlight field in Firestore and updates the local element.
   * @param element - The session element to toggle highlight for
   */
  protected toggleHighlight(element: any) {
    // Optimistically update the UI

    // Update in Firestore
    this.counselingService.toggleIndividualSessionHighlight(element)
      .then(() => {
        console.log('Highlight toggled successfully');
        // Log the action
        let activity = {
          date: new Date().getTime(),
          section: 'Individual Counseling',
          action: 'Toggle Highlight',
          description: `Session for ${element.childCode} ${element.isHighlight ? 'highlighted' : 'unhighlighted'} by user`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
      })
      .catch(err => {
        console.error('Error toggling highlight:', err);
        // Revert the optimistic update on error
        element.isHighlight = !element.isHighlight;
      });
    element.isHighlight = !element.isHighlight;

  }



  downloadExcel() {
    const tableData = this.dataSource.filteredData;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Session Date</th>
        <th>Child Name</th>
        <th>Centre Name</th>
        <th>Challenges Faced</th>
        <th>Type</th>
        <th>Submitted By</th>
        <th>Created At</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${this.getDate(x.date)}</td>
        <td>${x.childName ?? '-'}</td>
        <td>${x.centreName ?? '-'}</td>
        <td>${x.challengesFaced ?? '-'}</td>
        <td>${x.type ?? '-'}</td>
        <td>${x.submittedBy ?? '-'}</td>
        <td>${
        x.createdAt
          ? this.datePipe.transform(
            x.createdAt.toDate?.() ?? x.createdAt,
            'dd/MM/yyyy'
          )
          : '-'
      }</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Individual_Counselling_Sessions_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
